import { injectable, Inject } from 'inversify-props';
import HttpClient from './http-client';
import CurrencyList from 'app/shared/models/currency-list.model';

@injectable()
export class SavedTripsService {
    @Inject() httpClient:HttpClient;
    constructor() {
    }

    public getSolutions(body: any) {
        return this.httpClient.post('/flights/solutions', body);
    }

    public getFavorites(body: any) {
        return this.httpClient.post('/favorites/get', body);
    }

    public getFlightsResults(body:any){
        return this.httpClient.post('/flights/results', body);
    }

    public removeTrip(body:any){
        return this.httpClient.post('/favorites/remove', body);
    }

    public async getCurrency(): Promise<CurrencyList> {
        return this.httpClient.get('/currency');
    }

}
